import React, { useState, useEffect, useRef } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import { useParams } from "react-router";
import { db } from "./firebase";
import { collection, getDocs, query, where } from "firebase/firestore";

// images
import Gift from "../images/gift.gif";
import Logo from "../images/25.png";
import Sale from "../images/logo-sale.png";
import Swipe from "../images/swipe2.gif";

// components
import "antd/dist/antd.css";
import {
  Button,
  Divider,
  Space,
  Affix,
  Col,
  Badge,
  Modal,
  Layout,
  Row,
  Carousel,
  Card,
  Spin,
  Avatar,
} from "antd";

import moment from "moment";
import { Animated } from "react-animated-css";
import {
  ContactsOutlined,
  GiftOutlined,
  TagOutlined,
  ShoppingOutlined,
} from "@ant-design/icons";

import EventCountDown from "./EventCountDown";
import TranslateButton from "./TranslateButton";
import "@pqina/flip/dist/flip.min.css";

const CryptoJS = require("crypto-js");

const { Footer } = Layout;

function Home() {
  // const encrypt = (data) => {
  //   return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(data));
  // };

  const decrypt = (data) => {
    return CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
  };

  let navigate = useNavigate();
  const { refcode } = useParams();
  const [allPackages, setAllPackages] = useState([]);
  const [ads, setAds] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cart, setCart] = useState([]);
  // const [loadingSwipe, setLoadingSwipe] = useState(false);

  useEffect(() => {
    setLoading(true);
    // setLoadingSwipe(true);

    setRefCode();
    checkStatusWeb();
    getAds();
    getCartandPackages();
    getLocation();

    setTimeout(() => {
      setLoading(false);
    }, 1000);

    // setTimeout(() => {
    //   setLoadingSwipe(false);
    // }, 4000);
  }, []);

  const setRefCode = () => {
    if (refcode !== undefined) {
      localStorage.setItem("RefCode", JSON.stringify(decrypt(refcode)));
    }
  };

  const checkStatusWeb = async () => {
    // let lastPageUrl = document.referrer
    // console.log(`Last visited page URL is ${lastPageUrl}`)

    const querySnapshot = await getDocs(
      query(collection(db, "control_web"), where("isactive", "==", false))
    );

    const res = querySnapshot.docs
      .map((doc) => doc.data())
      .filter(
        (x) =>
          moment().format("YYYY-MM-DD HH:mm:ss") >=
            moment().format(x.start_date, "YYYY-MM-DD HH:mm:ss") &&
          moment().format("YYYY-MM-DD HH:mm:ss") <=
            moment().format(x.end_date, "YYYY-MM-DD HH:mm:ss")
      );

    if (res.length !== 0) {
      navigate("/maintain");
    }
  };

  const getAds = async () => {
    const querySnapshot = await getDocs(
      query(collection(db, "Ads"), where("isactive", "==", true))
    );

    const res = querySnapshot.docs
      .map((doc) => doc.data())
      .filter(
        (x) =>
          moment().format("YYYY-MM-DD HH:mm:ss") >=
            moment().format(x.start_date, "YYYY-MM-DD HH:mm:ss") &&
          moment().format("YYYY-MM-DD HH:mm:ss") <=
            moment().format(x.end_date, "YYYY-MM-DD HH:mm:ss")
      );

    if (res.length !== 0 && res[0].img !== "") {
      setAds(res[0].img);
    }
  };

  const getCartandPackages = async () => {
    let type = "normal";

    if (
      JSON.parse(localStorage.getItem("Cart")) &&
      JSON.parse(localStorage.getItem("Cart")).length !== 0
    ) {
      const querySnapshot = await getDocs(
        query(collection(db, "packages"), where("isactive", "==", true))
      );
      const allPack = querySnapshot.docs.map((doc) => doc.data());

      const cartPack = JSON.parse(localStorage.getItem("Cart")).filter(
        (x) =>
          moment().format("YYYY-MM-DD HH:mm:ss") >=
            moment().format(x.start_date, "YYYY-MM-DD HH:mm:ss") &&
          moment().format("YYYY-MM-DD HH:mm:ss") <=
            moment().format(x.end_date, "YYYY-MM-DD HH:mm:ss") &&
          x.isactive === true
      );

      let arr = [];
      for (let i = 0; i < allPack.length; i++) {
        for (let j = 0; j < cartPack.length; j++) {
          if (
            allPack[i].ecoupon_code === cartPack[j].ecoupon_code &&
            allPack[i].isactive === cartPack[j].isactive &&
            allPack[i].start_date === cartPack[j].start_date &&
            allPack[i].end_date === cartPack[j].end_date
          ) {
            arr.push(cartPack[j]);
          }
        }
      }

      if (arr && arr.find((x) => x.type === "event") !== undefined) {
        type = "promotion_season";
      }

      setCart(arr);
      localStorage.removeItem("Cart");
      localStorage.setItem("Cart", JSON.stringify(arr));

      setIsModalVisible(false);
    } else {
      setIsModalVisible(true);
    }

    const querySnapshot = await getDocs(
      query(
        collection(db, "packages"),
        where("isactive", "==", true),
        where("type", "in", ["event", type, "special", "flashsale", "group"])
      )
    );

    const pcks = querySnapshot.docs.map((doc) => doc.data());

    setAllPackages(
      pcks.filter(
        (x) =>
          moment().format("YYYY-MM-DD HH:mm:ss") >=
            moment().format(x.start_date, "YYYY-MM-DD HH:mm:ss") &&
          moment().format("YYYY-MM-DD HH:mm:ss") <=
            moment().format(x.end_date, "YYYY-MM-DD HH:mm:ss")
      )
    );
  };

  const getLocation = () => {
    if (!navigator.geolocation) {
      // console.log("Geolocation is not supported by your browser");
    } else {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          var obj = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          localStorage.setItem("Position", JSON.stringify(obj));
        },
        (e) => {
          // console.log(e);
          // console.log("Unable to retrieve your location");
        }
      );
    }
  };

  const Loading = () => {
    return (
      <div className="center">
        <img src={Gift} alt="" style={{ width: "20%" }} />
        <br /> <p>Loading...</p>
      </div>
    );
  };

  const contentStyle = {
    height: "160px",
    color: "#fff",
    lineHeight: "160px",
    textAlign: "center",
    background: "#364d79",
  };

  return (
    <div style={{ minHeight: "80vh" }}>
      <TranslateButton />
      {/* BackTop removed to avoid overlapping floating buttons */}
      <Affix offsetTop={0}>
        <div
          style={{
            padding: "20px",
            background: "rgba(255,255,255,0.8)",
            lineHeight: "130%",
          }}
        >
          <>
            <Row>
              <Col span={21} style={{ textAlign: "left" }}>
                <span
                  style={{
                    color: "white",
                    fontSize: "20px",
                    paddingRight: "10px",
                  }}
                >
                  <NavLink to="/">
                    {" "}
                    <b>
                      <span style={{ color: "#1e366f", fontSize: "16px" }}>
                        {/* <img src={Logo} alt="" width={35} />  */} Bangkok
                        Hospital Hatyai <br />
                        <span style={{ color: "#b21e2a", fontSize: "14px" }}>
                          Shopping World
                        </span>
                      </span>
                    </b>
                  </NavLink>
                </span>
              </Col>
              <Col span={3} style={{ textAlign: "right" }}>
                <NavLink to="/cart">
                  <Badge
                    count={
                      cart.length !== 0
                        ? cart.filter((x) => x.type !== "option").length
                        : null
                    }
                  >
                    <div style={{ background: "white", borderRadius: "25px" }}>
                      <ShoppingOutlined
                        style={{
                          color: "#1e366f",
                          fontSize: "28px",
                          padding: "7px",
                        }}
                      />
                    </div>
                  </Badge>
                </NavLink>
              </Col>
            </Row>
          </>
        </div>
        <Divider style={{ margin: "0px" }} />
      </Affix>
      {/* <p>Last visited page URL is : {document.referrer}</p> */}
      {loading ? (
        <Loading />
      ) : (
        <>
          {allPackages.length !== 0 ? (
            <>
              {/* <Spin
                  tip={
                    <>
                      <img src={Swipe} />
                      <br />
                      <p style={{ color: "black", fontSize: "16px" }}>
                        เลื่อนเพื่อดูโปรแกรมตรวจ
                      </p>
                    </>
                  }
                  spinning={loadingSwipe}
                  indicator={null}
                > */}
              <div
                style={{
                  textAlign: "center",
                }}
              >
                {allPackages.filter((x) => x.type === "event").length !== 0 ? (
                  <>
                    <Animated animationIn="fadeIn">
                      {/* <Carousel autoplay>
                        <div>
                          <h3 style={contentStyle}>1</h3>
                        </div>
                        <div>
                          <h3 style={contentStyle}>2</h3>
                        </div>
                      </Carousel> */}
                      <Carousel autoplay>
                        {allPackages
                          .filter((x) => x.type === "event")
                          .sort((a, b) => {
                            if (a.recordtime > b.recordtime) {
                              return -1;
                            }
                          })
                          .map((item) => (
                            <>
                              <div style={{ padding: "15px 15px 10px 15px" }}>
                                <NavLink to={`/events/${item.ecoupon_code}`}>
                                  <img
                                    style={{
                                      maxWidth: "100%",
                                      minHeight: "150px",
                                      maxHeight: "400px",
                                      borderRadius: "25px",
                                      boxShadow: "1px 2px 7px #3B5284",
                                      display:"block",
                                      marginLeft:"auto",
                                      marginRight:"auto",
                                    }}
                                    src={item.banner_img}
                                    alt=""
                                  />
                                </NavLink>
                              </div>
                              {/* <NavLink to={`/events/${item.ecoupon_code}`}>
                                <Button
                                  style={{
                                    color: "#b21e2a",
                                    borderColor: "#b21e2a",
                                    marginBottom: "30px",
                                  }}
                                  shape="round"
                                  type="primary"
                                  ghost
                                >
                                  ซื้อเลย !! พิเศษสำหรับคุณ
                                  <GiftOutlined />
                                </Button>
                              </NavLink> */}
                            </>
                          ))}
                      </Carousel>
                    </Animated>
                  </>
                ) : null}

                {allPackages.filter((x) => x.type === "flashsale").length !==
                0 ? (
                  <>
                    <Animated animationIn="fadeIn">
                      <div
                        style={{
                          // backgroundColor: "#fefbe5",
                          // borderRadius: "25px",
                          // padding: "10px",
                          textAlign: "left",
                        }}
                      >
                        <Row>
                          <Col span={14}>
                            <Animated
                              animationIn="tada"
                              animationInDelay="1000"
                            >
                              <img src={Sale} alt="" width={70} />
                              <span
                                style={{
                                  fontSize: "18px",
                                  fontWeight: "bold",
                                  color: "#b21e2a",
                                }}
                              >
                                Flash Health
                              </span>
                            </Animated>
                          </Col>
                          <Col span={10} style={{ textAlign: "right" }}>
                            <br />
                            {/* <EventCountDown
                          value={
                            allPackages.filter((x) => x.type === "flashsale")[0]
                              .end_date + "+07:00"
                          }
                        /> */}
                          </Col>
                        </Row>

                        <div
                          style={{
                            width: "100%",
                            overflow: "auto",
                            padding: "10px",
                          }}
                        >
                          <center>
                            <Space direction="horizontal">
                              {allPackages
                                .filter((x) => x.type === "flashsale")
                                .sort((a, b) => {
                                  if (a.modifytime > b.modifytime) {
                                    return -1;
                                  }
                                })
                                .map((product) => {
                                  return (
                                    <>
                                      <NavLink
                                        to={`/products/${product.ecoupon_code}`}
                                      >
                                        <div
                                          style={{
                                            height: "430px",
                                            width: "250px",
                                            background: "rgba(255,255,255,0.9)",
                                            borderRadius: "25px",
                                            padding: "5px",
                                            position: "relative",
                                          }}
                                        >
                                          <img
                                            style={{
                                              margin: "5px",
                                              height: "230px",
                                              borderRadius: "25px",
                                              boxShadow: "1px 2px 10px silver",
                                            }}
                                            src={product.img}
                                            alt=""
                                          ></img>
                                          {product.price !== 0 ? (
                                            <>
                                              <div
                                                className="circle"
                                                style={{
                                                  position: "absolute",
                                                  top: "0px",
                                                  right: "0px",
                                                }}
                                              >
                                                <p className="content">
                                                  <span
                                                    style={{ fontSize: "20px" }}
                                                  >
                                                    -
                                                    {Math.floor(
                                                      ((product.price -
                                                        product.price_pro) /
                                                        product.price) *
                                                        100
                                                    )}
                                                    %
                                                  </span>
                                                  <br />
                                                  OFF
                                                </p>
                                              </div>
                                            </>
                                          ) : null}
                                          <br />
                                          <br />
                                          <p style={{ color: "black" }}>
                                            {product.name}
                                          </p>
                                          {/* {product.detail !== "" ? (
                                            <>
                                              {" "}
                                              <span
                                                style={{
                                                  fontSize: "14px",
                                                  color: "red",
                                                }}
                                              >
                                                {product.detail}{" "}
                                              </span>
                                              <br />
                                              <br />
                                            </>
                                          ) : null} */}
                                          <span
                                            style={{
                                              fontSize: "16px",
                                              color: "#b21e2a",
                                            }}
                                          >
                                            <b>
                                              {/* <TagOutlined />  */}฿{" "}
                                              {product.price_pro.toLocaleString(
                                                "en-US"
                                              )}
                                            </b>
                                          </span>

                                          <br />
                                          {product.price !== 0 ? (
                                            <>
                                              <span
                                                style={{
                                                  fontSize: "14px",
                                                  color: "silver",
                                                }}
                                              >
                                                ราคาปกติ{" "}
                                                <span
                                                  style={{
                                                    textDecoration:
                                                      "line-through",
                                                    textDecorationColor: "red",
                                                  }}
                                                >
                                                  {product.price.toLocaleString(
                                                    "en-US"
                                                  )}
                                                </span>
                                              </span>
                                            </>
                                          ) : null}
                                        </div>
                                        <br />
                                      </NavLink>
                                    </>
                                  );
                                })}
                            </Space>
                          </center>
                        </div>
                      </div>
                    </Animated>
                  </>
                ) : null}

                {allPackages.filter((x) => x.type === "special").length !==
                0 ? (
                  <>
                    <Divider orientation="left">
                      โปรโมชั่นราคาพิเศษสำหรับคุณ
                    </Divider>
                    <div
                      style={{
                        width: "100%",
                        overflow: "auto",
                        padding: "10px",
                      }}
                    >
                      <center>
                        <Space direction="horizontal">
                          {allPackages != null
                            ? allPackages
                                .sort((a, b) => {
                                  if (a.recordtime > b.recordtime) {
                                    return -1;
                                  }
                                })
                                .map((product) =>
                                  product.type === "special" ? (
                                    <>
                                      <NavLink
                                        to={`/products/${product.ecoupon_code}`}
                                      >
                                        <div
                                          style={{ height: "450px" }}
                                          // onClick={() =>
                                          //   localStorage.setItem(
                                          //     "Product",
                                          //     JSON.stringify(product)
                                          //   )
                                          // }
                                        >
                                          <img
                                            src={product.img}
                                            style={{
                                              margin: "6px",
                                              height: "230px",
                                              borderRadius: "25px",
                                              boxShadow: "1px 2px 10px silver",
                                            }}
                                          ></img>

                                          <br />
                                          <br />
                                          <p style={{ color: "black" }}>
                                            {product.name}
                                          </p>
                                          {/* {product.detail !== "" ? (
                                            <>
                                              {" "}
                                              <span
                                                style={{
                                                  fontSize: "14px",
                                                  color: "red",
                                                }}
                                              >
                                                {product.detail}{" "}
                                              </span>
                                              <br />
                                              <br />
                                            </>
                                          ) : null} */}
                                          <span
                                            style={{
                                              fontSize: "16px",
                                              color: "#b21e2a",
                                            }}
                                          >
                                            <b>
                                              {/* <TagOutlined /> */}฿{" "}
                                              {product.price_pro.toLocaleString(
                                                "en-US"
                                              )}
                                            </b>
                                          </span>
                                          <br />
                                          <span
                                            style={{
                                              fontSize: "14px",
                                              color: "silver",
                                            }}
                                          >
                                            ราคาปกติ{" "}
                                            <span
                                              style={{
                                                textDecoration: "line-through",
                                                textDecorationColor: "red",
                                              }}
                                            >
                                              {product.price.toLocaleString(
                                                "en-US"
                                              )}
                                            </span>
                                          </span>
                                        </div>
                                      </NavLink>
                                    </>
                                  ) : null
                                )
                            : null}
                        </Space>
                      </center>
                    </div>
                  </>
                ) : null}

                {allPackages.filter((x) => x.type === "group").length !== 0 ? (
                  <>
                    <Divider orientation="center">
                      <div
                        style={{
                          fontSize: "18px",
                          background: "rgba(178, 30, 42,0.8)",
                          color: "white",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                          paddingRight: "20px",
                          paddingLeft: "20px",
                          // width:'150px',
                          borderRadius: "25px",
                        }}
                      >
                        แพ็คเกจสุดคุ้ม
                      </div>
                    </Divider>
                    <div
                      style={{
                        width: "100%",
                        overflow: "auto",
                        padding: "10px",
                      }}
                    >
                      <center>
                        <Space direction="horizontal">
                          {allPackages
                            .filter(
                              (x) =>
                                x.type !== "event" &&
                                x.type !== "flashsale" &&
                                x.type !== "special" &&
                                x.type !== "normal"
                            )
                            .sort((a, b) => {
                              if (a.recordtime > b.recordtime) {
                                return -1;
                              }
                            })
                            .map((product) => {
                              return (
                                <>
                                  <NavLink
                                    to={`/products/${product.ecoupon_code}`}
                                  >
                                    <div
                                      style={{
                                        height: "430px",
                                        width: "250px",
                                        background: "rgba(255,255,255,0.9)",
                                        borderRadius: "25px",
                                        padding: "5px",
                                        position: "relative",
                                      }}
                                    >
                                      <img
                                        style={{
                                          margin: "5px",
                                          height: "230px",
                                          borderRadius: "25px",
                                          boxShadow: "1px 2px 10px silver",
                                        }}
                                        src={product.img}
                                        alt=""
                                      ></img>
                                      {product.price !== 0 ? (
                                        <>
                                          <div
                                            className="circle"
                                            style={{
                                              position: "absolute",
                                              top: "0px",
                                              right: "0px",
                                            }}
                                          >
                                            <p className="content">
                                              <span
                                                style={{ fontSize: "20px" }}
                                              >
                                                -
                                                {Math.floor(
                                                  ((product.price -
                                                    product.price_pro) /
                                                    product.price) *
                                                    100
                                                )}
                                                %
                                              </span>
                                              <br />
                                              OFF
                                            </p>
                                          </div>
                                        </>
                                      ) : null}
                                      <br />
                                      <br />
                                      <p style={{ color: "black" }}>
                                        {product.name}
                                      </p>
                                      <span
                                        style={{
                                          fontSize: "16px",
                                          color:
                                            cart.length !== 0 &&
                                            cart.find(
                                              (x) => x.type === "event"
                                            ) !== undefined
                                              ? "#6D583A"
                                              : "#b21e2a",
                                        }}
                                      >
                                        <b>
                                          {/* <TagOutlined />  */}฿{" "}
                                          {product.price_pro.toLocaleString(
                                            "en-US"
                                          )}
                                        </b>
                                      </span>
                                      {/* {cart.length !== 0 &&
                                      cart.find((x) => x.type === "event") !==
                                        undefined ? (
                                        <> */}
                                      <br />
                                      {product.price !== 0 ? (
                                        <>
                                          <span
                                            style={{
                                              fontSize: "14px",
                                              color: "silver",
                                            }}
                                          >
                                            ราคาปกติ{" "}
                                            <span
                                              style={{
                                                textDecoration: "line-through",
                                                textDecorationColor: "red",
                                              }}
                                            >
                                              {product.price.toLocaleString(
                                                "en-US"
                                              )}
                                            </span>
                                          </span>
                                        </>
                                      ) : null}
                                      {/* </>
                                      ) : null} */}
                                    </div>
                                  </NavLink>
                                </>
                              );
                            })}
                        </Space>
                      </center>
                      <br />
                    </div>
                  </>
                ) : null}

                {allPackages.filter((x) => x.type === "normal").length !== 0 ? (
                  <>
                    <Divider orientation="center">
                      <div
                        style={{
                          fontSize: "18px",
                          background: "rgba(178, 30, 42,0.8)",
                          color: "white",
                          paddingTop: "5px",
                          paddingBottom: "5px",
                          paddingRight: "20px",
                          paddingLeft: "20px",
                          // width:'110%',
                          borderRadius: "25px",
                        }}
                      >
                        โปรแกรมตรวจสุขภาพ
                      </div>
                    </Divider>
                    <div
                      style={{
                        width: "100%",
                        overflow: "auto",
                        padding: "10px",
                      }}
                    >
                      <center>
                        <Space direction="horizontal">
                          {allPackages
                            .filter(
                              (x) =>
                                x.type !== "event" &&
                                x.type !== "flashsale" &&
                                x.type !== "special" &&
                                x.type !== "group"
                            )
                            .sort((a, b) => {
                              if (a.recordtime > b.recordtime) {
                                return -1;
                              }
                            })
                            .map((product) => {
                              return (
                                <>
                                  <NavLink
                                    to={`/products/${product.ecoupon_code}`}
                                  >
                                    <div
                                      style={{
                                        height: "430px",
                                        width: "250px",
                                        width: "250px",
                                        background: "rgba(255,255,255,0.9)",
                                        borderRadius: "25px",
                                        padding: "5px",
                                        position: "relative",
                                      }}
                                    >
                                      <img
                                        style={{
                                          margin: "5px",
                                          height: "230px",
                                          borderRadius: "25px",
                                          boxShadow: "1px 2px 10px silver",
                                        }}
                                        src={product.img}
                                        alt=""
                                      ></img>
                                      {product.price !== 0 ? (
                                        <>
                                          <div
                                            className="circle"
                                            style={{
                                              position: "absolute",
                                              top: "0px",
                                              right: "0px",
                                            }}
                                          >
                                            <p className="content">
                                              <span
                                                style={{ fontSize: "20px" }}
                                              >
                                                -
                                                {Math.floor(
                                                  ((product.price -
                                                    product.price_pro) /
                                                    product.price) *
                                                    100
                                                )}
                                                %
                                              </span>
                                              <br />
                                              OFF
                                            </p>
                                          </div>
                                        </>
                                      ) : null}
                                      <br />
                                      <br />
                                      <p style={{ color: "black" }}>
                                        {product.name}
                                      </p>
                                      <span
                                        style={{
                                          fontSize: "16px",
                                          color:
                                            cart.length !== 0 &&
                                            cart.find(
                                              (x) => x.type === "event"
                                            ) !== undefined
                                              ? "#6D583A"
                                              : "#b21e2a",
                                        }}
                                      >
                                        <b>
                                          {/* <TagOutlined />  */}฿{" "}
                                          {product.price_pro.toLocaleString(
                                            "en-US"
                                          )}
                                        </b>
                                      </span>
                                      {/* {cart.length !== 0 &&
                                      cart.find((x) => x.type === "event") !==
                                        undefined ? (
                                        <> */}
                                      <br />
                                      {product.price !== 0 ? (
                                        <>
                                          <span
                                            style={{
                                              fontSize: "14px",
                                              color: "silver",
                                            }}
                                          >
                                            ราคาปกติ{" "}
                                            <span
                                              style={{
                                                textDecoration: "line-through",
                                                textDecorationColor: "red",
                                              }}
                                            >
                                              {product.price.toLocaleString(
                                                "en-US"
                                              )}
                                            </span>
                                          </span>
                                        </>
                                      ) : null}
                                      {/* </>
                                      ) : null} */}
                                    </div>
                                    <br />
                                  </NavLink>
                                </>
                              );
                            })}
                        </Space>
                      </center>
                    </div>
                  </>
                ) : null}
              </div>
              {/* </Spin> */}
              <Footer style={{ backgroundColor: "#1e366f", color: "white" }}>
                Currently v2.0.0.Copyright © {moment().format("yyyy")} BHH
                Shopping World <br />
                Data Analytics and Innovation Centre, Bangkok Hospital Hatyai.
                All rights reserved
                <br />
                <ContactsOutlined /> E-coupon contact: bhhanalytic@gmail.com
                Tel.: 074-272800
              </Footer>
            </>
          ) : (
            <div className="center">
              <br />
              <br />
              <br />
              <p>พบกันเร็วๆนี้</p>
              <br />
            </div>
          )}
        </>
      )}

      {ads !== null ? (
        <Modal
          title=""
          visible={isModalVisible}
          footer={null}
          onCancel={() => setIsModalVisible(false)}
          width={300}
          bodyStyle={{ padding: "0px" }}
        >
          <img src={ads} alt="" width="100%" />
        </Modal>
      ) : null}
    </div>
  );
}

export default Home;
